var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlaidLogoWhite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0847 0L2.87151 2.68656L0.0568686 13.002L3.5771 16.632L0 20.2021L2.64895 30.5626L12.8179 33.4163L16.3957 29.8455L19.9159 33.4748L30.1291 30.7883L32.9431 20.4722L29.4235 16.8435L33.0006 13.2734L30.3517 2.9122L20.1813 0.0585261L16.6049 3.62862L13.0847 0ZM6.81721 4.67081L12.1973 3.2549L14.5499 5.68056L11.1189 9.10469L6.81721 4.67081ZM18.6276 5.71299L21.0182 3.32753L26.3751 4.83087L22.0032 9.19353L18.6276 5.71299ZM3.28012 12.1551L4.76222 6.72204L9.06246 11.1559L5.6321 14.5801L3.28012 12.1551ZM24.0245 11.2786L28.3964 6.91454L29.7907 12.3723L27.4008 14.7585L24.0245 11.2786ZM13.1409 11.1891L16.5719 7.76493L19.9468 11.2455L16.5165 14.6696L13.1409 11.1891ZM7.65479 16.6644L11.0852 13.2403L14.4622 16.7208L11.0304 20.145L7.65479 16.6644ZM18.5392 16.754L21.9695 13.3299L25.3451 16.8104L21.9141 20.2345L18.5392 16.754ZM3.20851 21.1025L5.5998 18.7157L8.9747 22.1969L4.60425 26.5589L3.20851 21.1025ZM13.0524 22.2293L16.4835 18.8052L19.8591 22.2858L16.4287 25.7099L13.0524 22.2293ZM23.9361 22.3196L27.3671 18.8955L29.7198 21.3204L28.2384 26.7535L23.9361 22.3196ZM6.62554 28.6447L10.9967 24.2806L14.3737 27.7611L11.9824 30.148L6.62554 28.6447ZM18.4507 27.7943L21.8811 24.3701L26.182 28.8047L20.8027 30.2199L18.4507 27.7943Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlaidLogoWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Plaid-logo-white.ebd2c133246cdf0050ad12faae196e93.svg";